import React from 'react';

const SessionLoader = () => {
    return (
        <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(255, 255, 255, 0.95)',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 99999,
            textAlign: 'center',
            padding: '20px'
        }}>
            <div style={{
                width: '50px',
                height: '50px',
                border: '5px solid #f3f3f3',
                borderTop: '5px solid #3498db',
                borderRadius: '50%',
                animation: 'spin 1s linear infinite',
                marginBottom: '20px'
            }}></div>
            <h2 style={{
                margin: '0',
                fontSize: '24px',
                color: '#333',
                fontWeight: '600'
            }}>Session initiating...</h2>
            <p style={{
                margin: '10px 0 0',
                fontSize: '16px',
                color: '#666'
            }}>Please wait</p>

            <style>{`
                @keyframes spin {
                    0% { transform: rotate(0deg); }
                    100% { transform: rotate(360deg); }
                }
            `}</style>
        </div>
    );
};

export default SessionLoader;
